import React from 'react';
import Select from 'react-select';
import {locationBlue, locationRed} from '../../../assets/images/images';
import {customStyles, DropdownIndicator} from '../../../components';
import {useFraudCheck, usePersistFraudData} from '../../../hooks/useFraudCheck';
import {Card, Wrapper} from '../FraudCheckScreens';

export const DetectWithDigitalAddress = () => {
  const {setSelectedStatus, selectedStatus, setConfig, config, STATUSES} =
    useFraudCheck({
      action: 'pending',
    });

  const UPDATED_STATUSES = [...STATUSES];
  const statusData = usePersistFraudData({
    config,
    selectedStatus,
    actionKey: 'action',
    COLLECTION: UPDATED_STATUSES,
  });

  return (
    <Wrapper>
      <Card
        src={locationBlue}
        extension={
          <div className="flex flex-col gap-1">
            <p className="text-grey font-medium">Detect with Digital Address</p>
            <p className="text-body text-sm gap-1">
              Real-time geolocation match
            </p>
          </div>
        }
      />

      <Card
        extension={
          <p className="text-grey font-medium">
            If tracked geolocation (from device/IP) does not match the submitted
            address
          </p>
        }
        src={locationRed}
      >
        <div className="text-start w-full">
          <label htmlFor="status" className="mb-2 relative">
            Set status to
          </label>
          {statusData !== undefined && (
            <Select
              defaultValue={statusData}
              value={statusData || UPDATED_STATUSES[0]}
              onChange={status => {
                setSelectedStatus(status);
                setConfig({...config, action: status.value});
              }}
              options={UPDATED_STATUSES}
              className="basic-multi-select"
              classNamePrefix="react-select"
              components={{DropdownIndicator}}
              styles={customStyles}
              menuPlacement="auto"
              isSearchable={false}
            />
          )}
        </div>
      </Card>
    </Wrapper>
  );
};
